import { Component, OnInit, Inject, Input } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";

export interface XsMensajeParametro {
  titulo: string;
  mensaje: string;
  icono: string;
}

@Component({
  selector: "app-xs-message-box",
  templateUrl: "./xs-message-box.component.html",
  styleUrls: ["./xs-message-box.component.css"]
})
export class XsMessageBoxComponent implements OnInit {
  imagenIcono: string = "";
  baseUrl: string = "";

  constructor(
    public dialogRef: MatDialogRef<XsMessageBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public xsMensajeParametro: XsMensajeParametro,
    @Inject("BASE_URL") baseUrl: string
  ) {
    this.baseUrl = baseUrl;
  }

  ngOnInit() {
    this.obtenerImagenIcono();
  }

  obtenerImagenIcono() {
    console.log("APP_BASE_HREF: ", this.baseUrl);
    this.imagenIcono = this.baseUrl;
    switch (this.xsMensajeParametro.icono) {
      case "XS_OK":
        this.imagenIcono = "assets/images/xs-msg-box/msg_ok.png";
        break;
      case "XS_PREGUNTA":
        this.imagenIcono = "assets/images/xs-msg-box/msg_preg.png";
        break;
      case "XS_ADMIRACION":
        this.imagenIcono = "assets/images/xs-msg-box/msg_admira.png";
        break;
      case "XS_TRISTE":
        this.imagenIcono = "assets/images/xs-msg-box/msg_triste.png";
        break;
      case "XS:ERROR":
        this.imagenIcono = "assets/images/xs-msg-box/msg_error.png";
        break;
      case "XS_IDEA":
        this.imagenIcono = "assets/images/xs-msg-box/msg_idea.png";
        break;
      default:
        this.imagenIcono = "assets/images/xs-msg-box/msg_info.png";
        break;
    }
  }

  onClickAceptar() {
    this.dialogRef.close({ data: null, estado: "ACEPTAR" });
  }

  onClickCancelar() {
    this.dialogRef.close({ data: null, estado: "CANCELAR" });
  }
}
